export const genGetURL = (url: string, params?: { [key: string]: any }) => {
    if (!params) return url;
    let copyUrl = url;
    copyUrl += copyUrl.indexOf('?') === -1 ? '?' : '&';
    Object.keys(params).forEach((key) => {
        const val = params[key];
        if (val !== null && val !== undefined) {
            copyUrl += `${key}=${encodeURIComponent(val)}&`;
        }
    });
    return copyUrl.replace(/&$/, '');
};

export const isZeroOrNul = (val?: string | number) => {
    return val === '' || val === 0;
};

export const greaterZero = (val: string): number => Math.max(Number(val) || 1, 1);
